import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { Messages } from '../../../codegen/Localize';
import { IMetricWithParsedData, parseMetrics } from '../../../metrics';
import { Metrics } from '../../../ts/resources/Metrics';
import { IMetricWithSummaryData } from '../../../ts/ServerApi/types/IMetricWithSummaryData';
import { UpdateMetricsValues } from '../../actions/AppActionTypes';
import { requestFailed } from '../../actions/RequestFailedAction';
import { UpdateMetricsActions, updateMetricsValueRequestSucceeded } from '../../actions/spaces/UpdateMetricsActions';
import { ServiceLocator } from '../../ServiceLocator';

export function* handleUpdateMetricValuesRequest(action: UpdateMetricsActions) {
  try {
    const luids: string[] = [];

    for(let item of action.metrics){
      luids.push(item.luid);
    }

    const metrics: ReadonlyArray<IMetricWithSummaryData> = yield call(getMetricsByLuids, luids);
    const parsedMetrics = parseMetrics(metrics);
    yield put(updateMetricsValueRequestSucceeded(parsedMetrics));
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export async function getMetricsByLuids(luids: string[]): Promise<IMetricWithSummaryData[]> {
    const metricsResource = ServiceLocator.get<Metrics>('Metrics');
    const metrics = await metricsResource.getMetricsByLuids(luids);
    if (metrics.metrics && metrics.metrics.length >= 1) {return metrics.metrics;}
  }

export function* rootMetricSpaceSagas(): SagaIterator {
  yield takeLatest(UpdateMetricsValues, handleUpdateMetricValuesRequest);
}
